import React, {Component} from 'react';
import {getActiveClients} from "../../services/ClientsService";
import {Spin, Table, Tag} from 'antd';
import Moment from "react-moment";

class SocketActiveSessions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: []
        };
    }

    componentDidMount() {
        this.setState({
            isLoading: true
        });

        getActiveClients().then(response => {
            this.setState({
                data: response.content,
                isLoading: false
            });
        });
    }

    render() {
        if (this.state.isLoading) {
            return <Spin size="large"/>;
        }

        const columns = [{
            title: 'Fecha',
            dataIndex: 'date',
            key: 'date',
            render: date => <Moment date={date} format="DD/MM/YYYY hh:mm:ss a"/>
        }, {
            title: 'Usuario',
            dataIndex: 'user',
            key: 'user'
        }, {
            title: 'Versión',
            dataIndex: 'version',
            key: 'version'
        }, {
            title: 'Origen',
            dataIndex: 'source',
            key: 'source'
        }, {
            title: 'Canales',
            dataIndex: 'channels',
            key: 'channels',
            render: channels => {
                const inner = channels.map(c => <Tag color="#2db7f5">{c}</Tag>);
                return <div>{inner}</div>;
            }
        }];

        const expandedRowRender = (data) => {
            return <div>
                <p>{data['id']}</p>
                <p>{data['userAgent']}</p>
            </div>
        };

        return <div>
            <h2 className="action-separator-x2">{'Sockets'}</h2>
            <Table dataSource={this.state.data} columns={columns} bordered loading={this.state.loading}
                   size="small" rowKey="id" expandedRowRender={expandedRowRender}/>
        </div>
    }
}

export default SocketActiveSessions;


// WEBPACK FOOTER //
// ./src/app/views/clients/SocketActiveSessions.js